export class CompanyBusiness {
    public id: number;
    public uuid: string;
    public description: string;
}